import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const MobileMenu = ({ isOpen, onClose, navigationItems, currentPath }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleLinkClick = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-1100 md:hidden"
      onClick={handleBackdropClick}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black bg-opacity-50" />
      
      {/* Menu Panel */}
      <div className="absolute top-0 right-0 w-80 max-w-full h-full bg-surface shadow-large">
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-border">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Waves" size={16} color="white" />
              </div>
              <span className="font-heading font-semibold text-primary">
                AquaClean Pro
              </span>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-md text-text-secondary hover:text-primary hover:bg-primary/5 nav-transition"
            >
              <Icon name="X" size={20} />
            </button>
          </div>

          {/* Navigation Items */}
          <nav className="flex-1 px-4 py-6">
            <div className="space-y-2">
              {navigationItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={handleLinkClick}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg nav-transition ${
                    currentPath === item.path
                      ? 'text-primary bg-primary/10' :'text-text-primary hover:text-primary hover:bg-primary/5'
                  }`}
                >
                  <Icon name={item.icon} size={20} />
                  <span className="font-medium">{item.label}</span>
                </Link>
              ))}
            </div>
          </nav>

          {/* Contact Information */}
          <div className="p-4 border-t border-border">
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-sm">
                <Icon name="Phone" size={16} className="text-accent" />
                <span className="font-mono text-text-secondary">+506 8888-8888</span>
              </div>
              <div className="flex items-center space-x-3 text-sm">
                <Icon name="MessageCircle" size={16} className="text-success" />
                <span className="text-text-secondary">WhatsApp disponible</span>
              </div>
              <div className="flex items-center space-x-3 text-sm">
                <Icon name="Clock" size={16} className="text-warning" />
                <span className="text-text-secondary">Lun-Sáb 7AM-6PM</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;